export enum OptionFilterEnum {
  GlobalStatuses = "GlobalStatuses",
  Projects = "Projects",
  Tags = "Tags",
  Namespaces = "Namespaces",
  Types = "Types",
  Difficultys = "Difficultys",
  Queues = "Queues",
  Statuses = "Statuses",
  Priorities = "Priorities",
}
